<template>
  <div :style="headerCss" id="reportHeader" @drop="drop($event)" @dragover="allowDrop($event)">
    <div :style="{ position: 'absolute', width: headerCss.width, height: headerCss.height }">
      <ReportElement v-for="(elm, index) in header.elements" :index="index" :elmData="elm" :maxPos="maxPos" @removeClicked="remove(index)"></ReportElement>
    </div>
  </div>
</template>
<script>
  import ReportElement from './ReportElement'
  export default {
    name: 'ReportHeader',
    props: ['orientation', 'header'],
    components: { ReportElement },
    computed: {
      headerCss () {
        return {
          // backgroundColor: '#efefef',
          // backgroundColor: '#ccc',
          backgroundColor: 'rgba(200, 200, 200, 0.1)',
          fontSize: '16px',
          width: this.header.width + 'in',
          height: this.header.height + 'in',
          top: this.header.top + 'in',
          left: this.header.left + 'in'
        }
      },
      maxPos () {
        return {
          left: this.header.width,
          top: this.header.height
        }
      }
    },
    watch: {
      orientation (val) {
        console.log('header this.orientation = ' + val)
        this.$forceUpdate()
      }
    },
    methods: {
      remove (index) {
        this.header.elements.splice(index, 1)
      },
      allowDrop (event) {
        event.preventDefault()
      },
      drop (event) {
        event.preventDefault()
        console.log(event)
        console.log(event.target)
        console.debug(event.dataTransfer.types)
        let dataJson = event.dataTransfer.getData('data')
        console.log(dataJson)
        let data = JSON.parse(dataJson)
        console.log(data)
        if (data.dropOn === 'All' || data.dropOn === 'Header') {
          let top = Number(event.offsetY / 96).toFixed(4)
          let left = Number(event.offsetX / 96).toFixed(4)
          let fixedWidth = 1
          let fixedHeight = 0.25
          this.header.elements.push({
            text: data.name,
            type: 'text',
            top: top,
            left: left,
            width: fixedWidth,
            height: fixedHeight,
            bold: true,
            align: 'right'
          })
          this.$forceUpdate()
        } else {
          console.log('Can NOt drop this item on Header')
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ReportHeader.vue?190ef46c